import { render, staticRenderFns } from "./CategoryHubTile.vue?vue&type=template&id=9c10121c&scoped=true"
import script from "./CategoryHubTile.vue?vue&type=script&lang=js"
export * from "./CategoryHubTile.vue?vue&type=script&lang=js"
import style0 from "./CategoryHubTile.vue?vue&type=style&index=0&id=9c10121c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c10121c",
  null
  
)

export default component.exports